import { render, staticRenderFns } from "./getInboxList.vue?vue&type=template&id=de0013be&lang=pug"
import script from "./getInboxList.vue?vue&type=script&lang=js"
export * from "./getInboxList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports